<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/empresa/desafios'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de desafios"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode visualizar as tarefas do desafio selecionado, além
              de editar e visualizar as submissões.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                Tarefas
                <base-button
                  size="sm"
                  type="primary"
                  class="float-right"
                  :custom="true"
                  @click="handleNewTask()"
                  ><i class="fas fa-plus mr-1"></i> Nova tarefa
                </base-button>
              </h3>
            </div>
            <div class="card-body pb-2">
              <div class="vld-parent" ref="list_open_tasks">
                <task-list
                  :data="openTasks"
                  icon="fas fa-eye"
                  title="Ativas"
                  emptyMessage="Não há tarefas ativas no momento"
                />
                <div class="col-12 pr-0 text-right">
                  <base-button
                    type="link"
                    :custom="true"
                    v-if="openTasks.length === initialLimit"
                    @click="getOpenTasks()"
                    >Carregar todas tarefas ativas</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

import TaskList from "@/components/TaskList";

export default {
  name: "empresa_desafios_tarefas",
  components: {
    TaskList
  },
  data() {
    return {
      openTasks: [],
      initialLimit: 8,
      clicked: false,
      tasksLoaded: false
    };
  },
  async mounted() {
    await this.loadTasks();
    this.tasksLoaded = true;
  },
  methods: {
    async loadTasks() {
      const loader = this.$loading.show({
        container: this.$refs.list_open_tasks,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/company/challenges/${this.$route.params.id}/tasks`
        );
        if (data) this.openTasks = data;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar as tarefas ativas`);
      }
    },
    handleNewTask() {
      this.$router.push(
        `/empresa/desafios/${this.$route.params.id}/tarefas/nova`
      );
    }
  }
};
</script>
<style>
.card-profile-image img {
  width: 120px;
  height: 120px;
  border-radius: 10%;
}
</style>
